module.exports = __webpack_public_path__ + "static/media/14.380af981.png";